import { VeloStepper } from '../VeloStepper';
import styled from 'astroturf/react';

const StepContent = styled(VeloStepper.Content)`
  padding: 0.75rem 1.5rem;
`;

export { StepContent };
